import $ from 'jquery';
import {map, orderBy} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {
  updateGameWeek,
} from '../../../../../actions/entities/mxi/updateGameWeek';
import './CheckPlayers.css';

const initialState = {
  response: null,
  isSending: false,
  options: {},
  type: undefined,
};

class CheckPlayers extends React.Component {
  state = initialState;

  open = (options = {}) => {
    this.setState({options});
  };

  updatePlayers(confirm) {
    const {championship} = this.props;
    const {options} = this.state;

    this.props.dispatch(updateGameWeek(
      championship,
      options.gameWeek,
      confirm,
      () => {
        $('#checkPlayers').modal('hide');
        confirm === false && this.updatePlayers(true);
        if (confirm === true) {
          if (options.onSuccess) {
            options.onSuccess();
          }
          swal({
            title: `GAMEWEEK ${this.props?.gameWeek} ${this.props?.type?.toUpperCase()}${this.props?.type === 'open' ? 'ED' : 'D'} !`,
            type: 'success',
            html: ``,
          });
        }
      },
        (err) => {
          $('#checkPlayers').modal('hide');

          const generatePlayers = players => {
            const playerLines = players.map(player => {
              return `<tr><td style=vertical-align:top;>${
                player.playerId.split('_')?.[3]
              }</td><td style=font-weight:lighter; >${player.error} </td>`;
            });

            return [
              '<table class="table table-striped text-left">',
              '<thead class="fixedThead">',
              '<tr>',
              '<th>PlayerID</th>',
              '<th>Error</th>',
              '</tr>',
              '</thead>',
              '<tbody>',
              ...playerLines,
              '</tbody>',
              '</table>',
            ].join('');
          };

          swal({
            title: `Failed to ${this.props?.type}`,
            type: 'error',
            html:
              (err.message === 'poolUpdateFailures' && err.data?.errors)
                ? generatePlayers(err.data.errors)
                : err.message,
          });
        },
      ),
    );
  }

  onSubmit = () => {
    this.setState({isSending: true});
    this.updatePlayers(false);
  };

  renderPlayers = (clubsById) => {
    return (
      <table className="table table-responsive table-striped">
        <thead>
          <tr>
            <th>Team</th>
            <th className="id">ID</th>
            <th>Name</th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody>
          {map(
            orderBy(this.props.players, 'price', 'desc'),
            ({id, firstName, lastName, clubId, price}, index) => (
              <tr key={index} id={id}>
                <td data-id={clubId} title={clubId}>
                  {clubsById &&
                    clubsById[clubId] &&
                    clubsById[clubId].name['fr-FR']}
                </td>
                <td className="id">
                  {id && id.replace('mpg_championship_player_', '')}
                </td>
                <td>
                  {firstName} <span className="text-uppercase">{lastName}</span>
                </td>
                <td className="text-center">{price}</td>
              </tr>
            ),
          )}
        </tbody>
      </table>
    );
  };

  render() {
    const {options} = this.state;
    return (
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
          <h4 class="modal-title">{options.title || 'Confirm in & out ?'}</h4>
        </div>
        <div class="modal-body">
          {this.props.players && (
            <div id="check-players">
              <h4>Players</h4>
              {this.renderPlayers(this.props.clubsById)}
              <h4>TOTAL PLAYER FOR GAMEWEEK {this.props?.gameWeek} : {Object.keys(this.props?.players || {})?.length}</h4>
              <br />
              <h4>OK TO {this.props.type?.toUpperCase()} ? (last chance)</h4>
              <div class="modal-footer">
                <button
                  type="button"
                  data-dismiss="modal"
                  class="btn btn-danger">
                  NO
                </button>
                <button
                  onClick={this.onSubmit}
                  type="button"
                  class="btn btn-success">
                  YES
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

CheckPlayers.propTypes = {
  championship: PropTypes.number,
};

export default connect(null, dispatch => ({dispatch}), null, {forwardRef: true})(CheckPlayers);



// WEBPACK FOOTER //
// ./src/pages/MXI/Players/Widgets/CheckPlayers/index.js